import Graphic from "@arcgis/core/Graphic";

const symbol = {
  type: "simple-marker",
  size: 8,
  color: "#B74F6F",
  outline: {
    width: 1,
    color: "#FFF",
  },
};

export const getSurvey123PointData = ({ event, icon = undefined }) => {
  if (!event || !event.mapPoint) return;

  const pnt = event.mapPoint;
  const sym = icon ?? symbol;
  try {
    const surveyPoint = new Graphic({ geometry: pnt, sym });

    const iframe = "";

    return { marker: surveyPoint, iframe };
  } catch (err) {
    console.log("Error occurred while getting Survey123PointData", err);
  }
};
